export default [
  {
    header: 'barometer_surveys',
    roles: {
      admin: ["read", "write"],
      consultant: ["read", "write"],
      supervisor: ["read", "write"],
      director: ["read", "write"],
      client: ["read", "write"],
    }
  },
  {
    title: 'Designed',
    route: 'habit-barometerSurveyDesigned-list',
    icon: 'FileTextIcon',
    roles: {
      admin: ["read", "write"],
      consultant: ["read", "write"],
      supervisor: ["read", "write"],
      director: ["read", "write"],
      client: ["read", "write"],
    }
  },
  {
    title: 'Created',
    route: 'habit-barometerSurveyCreated-list',
    icon: 'FilePlusIcon',
    roles: {
      admin: ["read", "write"],
      consultant: ["read", "write"],
      supervisor: ["read", "write"],
      director: ["read", "write"],
      client: ["read", "write"],
    }
  },
  // {
  //   title: 'Dashboard',
  //   route: 'habit-customersOpinions-dashboard',
  //   icon: 'BarChart2Icon',
  //   roles: {
  //     admin: ["read", "write"],
  //     consultant: ["read", "write"],
  //     supervisor: ["read", "write"],
  //     client: ["read", "write"],
  //   }
  // }
]